class VideoModal extends window.BAO.CustomElement() {
	connectedCallback () {
		super.connectedCallback()
	}

	setupListeners () {
		this.handleOpen = this.handleOpen.bind(this)
		this.handleClose = this.handleClose.bind(this)
		this.handlePlayButton = this.handlePlayButton.bind(this)

		this.listeners.add(document, 'click', this.handleOpen)

		this.els?.closeTrigger?.elements.forEach(triggerEl => {
			this.listeners.add(triggerEl, 'click', this.handleClose)
		})

		if (this.els?.videoTrigger?.element) {
			this.listeners.add(this.els.videoTrigger.element, 'click', this.handlePlayButton)
		}
	}

	handleOpen (event) {
		// Get info from article to display in modal

		// article data
		const articleVideoUrl = event.target.closest('.vaara-world-main__article')?.getAttribute('data-vaara-world-video-url')
		const articleVideoThumbnail = event.target.closest('.vaara-world-main__article')?.getAttribute('data-vaara-world-video-thumbnail')
		const articleVideoContentInfo = event.target.closest('.vaara-world-main__article')?.querySelector('.vaara-world-main__content-info')

		// video modal elements
		const videoModalVideo = this.els?.videoPlayer?.element
		const videoModalContent = this.els?.modal?.element.querySelector('.video-modal__content')
		const videoModalContentInfo = videoModalContent.querySelector('.video-modal__content-info')
		const trigger = event.target.closest('[data-video-modal-external-el="openTrigger"]')

		// set video modal content
		if (articleVideoContentInfo) {
			videoModalContentInfo.innerHTML = articleVideoContentInfo.innerHTML
		}

		// set video modal thumbnail for the video
		if (articleVideoThumbnail) {
			videoModalVideo.poster = articleVideoThumbnail
		}

		// set video modal video source and load video
		if (articleVideoUrl) {
			videoModalVideo.querySelector('source').src = articleVideoUrl
			videoModalVideo.load()
		}

		if (!trigger) return

		const videoContainer = this.els?.modal?.element

		videoContainer.setAttribute('aria-hidden', 'false')
		videoContainer.classList.add('is-visible')

		// Prevent background scroll
		document.body.classList.add('is-popup-opened')
	}

	handleClose (event) {
		const video = this.els?.videoPlayer?.element
		const videoContainer = this.els?.modal?.element

		videoContainer.setAttribute('aria-hidden', 'true')
		videoContainer.classList.remove('is-visible')

		// Restore background scroll
		document.body.classList.remove('is-popup-opened')

		if (video) {
			video.pause()
		}
	}

	handlePlayButton (event) {
		event.preventDefault()
		const video = this.els?.videoPlayer?.element
		const playButton = this.querySelector('.video-modal__play')

		if (!video || !playButton) return

		video.play()
		playButton.style.display = 'none'

	}
}

// Define the custom element
if (!customElements.get('video-modal')) {
	customElements.define('video-modal', VideoModal)
}

